import { Interval } from 'api/types';

export const INTERVAL_15MIN: Interval = '15min';
export const INTERVAL_1HR: Interval = '1hr';
export const INTERVAL_6HR: Interval = '6hr';
export const INTERVAL_1DAY: Interval = '1day';
export const INTERVALS = [ INTERVAL_15MIN, INTERVAL_1HR, INTERVAL_6HR, INTERVAL_1DAY ];
export const INTERVAL_Monthly: Interval = 'Monthly';
export const INTERVAL_Yearly: Interval = 'Yearly';